import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Database' })({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 80,
        width: 1440,
        maxWidth: '100%',
        margin: 'auto'
    }
});
